import ConditionIcons from 'features/Weather/components/ConditionIcons/ConditionIcons';
import { temperatureColorScale } from 'utils/colors/colorScale.utils';
import {
  formatCurrentConditionTemperature,
  getCurrentConditionTemperature,
} from '../../../../utils/currentConditions.utils';

const CurrentConditionMarkerContent = ({ condition }) => {
  const temperature = getCurrentConditionTemperature(condition);
  const cityName = String(condition?.city_name || 'This location').trim();
  const formattedTemperature = formatCurrentConditionTemperature(temperature);
  const temperatureLabel =
    formattedTemperature === null ? 'Unavailable' : `${formattedTemperature}°F`;
  const accessibleTemperature =
    formattedTemperature === null
      ? 'temperature unavailable'
      : `${formattedTemperature} degrees Fahrenheit`;

  return (
    <div
      aria-label={`${cityName} current ${accessibleTemperature}`}
      className="current-conditions-marker"
      role="img"
      style={temperature === null ? undefined : { color: temperatureColorScale(temperature) }}
    >
      <span className="current-conditions-marker-temperature">{temperatureLabel}</span>
      <span aria-hidden="true" className="current-conditions-marker-icon">
        <ConditionIcons
          conditionId={condition?.icon}
          size={64}
          style={{ stroke: '#000000', strokeWidth: '0.5px' }}
        />
      </span>
    </div>
  );
};

export default CurrentConditionMarkerContent;
